export class AuthSoftLoginResult
{
    public success: boolean = false;
    public message: string = "";
    public redirectTo: string = "";
    public user: any = null;
}
